import React from "react";

import { useBoxFromBoxAssociation } from "../hooks/useBoxAssociation";

import { BoxDescription } from "../types/boxAssociation.types";

import { dateConverter } from "../../../utils/dateConverter";

import { limitString } from "../../../utils/stringUtils";

export type BoxInfoObject = BoxDescription;

export interface BoxInfoProps {
  info: keyof BoxInfoObject;
  boxAssociationId?: string;
  styled?: boolean;
  emptyText?: string;
  limitText?: number;
  renderComponent?: (config: {
    labelRender: React.ReactNode;
    goTo: () => void;
  }) => JSX.Element;
}

export default function BoxInfo({
  info,
  boxAssociationId,
  emptyText,
  styled,
  limitText,
}: BoxInfoProps) {
  const {
    boxQuery: { isLoading, isError, data },
  } = useBoxFromBoxAssociation(boxAssociationId || "");

  const attributBox = info as keyof BoxDescription;

  if (isLoading) return <>...</>;

  if (isError) return <>{emptyText ? emptyText : ""}</>;

  const boxData = data as BoxDescription | undefined;

  const convertValue = (info: keyof BoxInfoObject, value: any) => {
    switch (info) {
      case "recordDate":
        return dateConverter(value);
      case "FirstConnection":
        return dateConverter(value);
      case "LastConnexion":
        return dateConverter(value);
      case "ExpireDate":
        return dateConverter(value);
      case "SensorList":
        return Array.isArray(value) ? value.join(", ") : value;
      default:
        return value;
    }
  };

  const value = boxData?.[attributBox];

  return (
    <>
      {value !== undefined && value !== null && value !== ""
        ? limitString(
            String(convertValue(info, value)),
            limitText
          )
        : emptyText
        ? emptyText
        : ""}
    </>
  );
}

